// ./src/context/provider.js

import React, { createContext, useReducer } from 'react';

// Import reducers
import authReducer from './reducers/authReducer';
import studentReducer from './reducers/studentReducer';
import categoryReducer from './reducers/categoryReducer';
import courseReducer from './reducers/courseReducer';
import instructorReducer from './reducers/instructorReducer';
import recognizedInstructorReducer from './reducers/recognizedInstructorReducer';
import auditLogReducer from './reducers/auditLogReducer';
import messageReducer from './reducers/messageReducer';
import announcementReducer from './reducers/announcementReducer';
import iotReducer from './reducers/iotReducer';
import simulatorReducer from './reducers/simulatorReducer';
import visualCircuitReducer from './reducers/visualCircuitReducer';
import componentLibraryReducer from './reducers/componentLibraryReducer';
import knowledgeReducer from './reducers/knowledgeReducer';
import cognitiveReducer from './reducers/cognitiveReducer';

// Import initial states
import authInitialState from './initialStates/authInitialState';
import studentInitialState from './initialStates/studentInitialState';
import categoryInitialState from './initialStates/categoryInitialState';
import courseInitialState from './initialStates/courseInitialState';
import instructorInitialState from './initialStates/instructorInitialState';
import recognizedInstructorInitialState from './initialStates/recognizedInstructorInitialState';
import auditLogInitialState from './initialStates/auditLogInitialState';
import messageInitialState from './initialStates/messageInitialState';
import announcementInitialState from './initialStates/announcementInitialState';
import iotInitialState from './initialStates/iotInitialState';
import simulatorInitialState from './initialStates/simulatorInitialState';
import visualCircuitInitialState from './initialStates/visualCircuitInitialState';
import componentLibraryInitialState from './initialStates/componentLibraryInitialState';
import knowledgeInitialState from './initialStates/knowledgeInitialState';
import cognitiveInitialState from './initialStates/cognitiveInitialState';


export const GlobalContext = createContext({});

const GlobalProvider = ({ children }) => {
    // Auth state
    const [authState, authDispatch] = useReducer(authReducer, authInitialState);
    
    // Student state
    const [studentState, studentDispatch] = useReducer(studentReducer, studentInitialState);
    
    // Course state
    const [courseState, courseDispatch] = useReducer(courseReducer, courseInitialState);
    
    // Category state
    const [categoryState, categoryDispatch] = useReducer(categoryReducer, categoryInitialState);
    
    // Instructor state
    const [instructorState, instructorDispatch] = useReducer(instructorReducer, instructorInitialState);

    // Recognized Instructor state
    const [recognizedInstructorState, recognizedInstructorDispatch] = useReducer(
        recognizedInstructorReducer, 
        recognizedInstructorInitialState
    );

    // Audit Log state
    const [auditLogState, auditLogDispatch] = useReducer(auditLogReducer, auditLogInitialState);
    
    // Message state
    const [messageState, messageDispatch] = useReducer(messageReducer, messageInitialState);
    
    // Anoouncement state
    const [announcementState, announcementDispatch] = useReducer(announcementReducer, announcementInitialState);

    // iot state
    const [iotState, iotDispatch] = useReducer(iotReducer, iotInitialState);

    // visualCircuit state
    const [simulatorState, simulatorDispatch] = useReducer(simulatorReducer, simulatorInitialState);

    // visualCircuit state
    const [visualCircuitState, visualCircuitDispatch] = useReducer(visualCircuitReducer, visualCircuitInitialState);

    // visualCircuit state
    const [componentLibraryState, componentLibraryDispatch] = useReducer(componentLibraryReducer, componentLibraryInitialState);

    // visualCircuit state
    const [knowledgeState, knowledgeDispatch] = useReducer(knowledgeReducer, knowledgeInitialState);

    // cognitive state
    const [cognitiveState, cognitiveDispatch] = useReducer(cognitiveReducer, cognitiveInitialState);

    return (
        <GlobalContext.Provider
            value={{
                authState,
                authDispatch,
                studentState,
                studentDispatch,
                courseState,
                courseDispatch,
                categoryState,
                categoryDispatch,
                instructorState,
                instructorDispatch,
                recognizedInstructorState,
                recognizedInstructorDispatch,
                auditLogState,
                auditLogDispatch,
                messageState,
                messageDispatch,
                announcementState,
                announcementDispatch,
                iotState,
                iotDispatch,
                simulatorState,
                simulatorDispatch,
                visualCircuitState,
                visualCircuitDispatch,
                componentLibraryState,
                componentLibraryDispatch,
                knowledgeState,
                knowledgeDispatch,
                cognitiveState,
                cognitiveDispatch,
            }}
        >
            {children}
        </GlobalContext.Provider>
    );
};

export default GlobalProvider;